<template>
<div>
  <div :gutter="8" v-for="(item) in form.list" :key="item.id">
    <el-form-item label="讨论话题">
      <el-input v-model="item.topic" type="textarea" resize="none" :autosize="{minRows:1}"></el-input>
    </el-form-item>
    <el-form-item label="AI预设">
      <el-input v-model="item.ai_preset" type="textarea" resize="none" :autosize="{minRows:1}"></el-input>
    </el-form-item>
    <el-form-item label="练习目标">
      <el-input v-model="item.goal" type="textarea" resize="none" :autosize="{minRows:1}"></el-input>
    </el-form-item>
    <el-form-item label="练习模式">
      <div class="inline-block w100">
        <el-radio-group v-model="item.mode">
          <el-radio-button :label="0">练习导向/自由讨论模式</el-radio-button>
          <el-radio-button :label="1">目标导向/简单模式</el-radio-button>
        </el-radio-group>
      </div>
    </el-form-item>
    <el-form-item label="GPT第一句话">
      <el-input v-model="item.prompt" type="textarea" resize="none" :autosize="{minRows:1}"></el-input>
    </el-form-item>
    <el-form-item label="GPT判定">
      <el-input v-model="item.endpoint" type="textarea" resize="none" :autosize="{minRows:1}"></el-input>
    </el-form-item>
  </div>
</div>
</template>

<script>
import baseList from "./base-list.js";

export default {
  name: "ai_topic_form",
  props: {
    form: Object
  },
  data() {
    return {
      type: 1,
    }
  },
  mixins: [baseList],
  watch: {
    form: {
      immediate: true,
      handler(val) {
        if (!val.list) {
          val.list = [];
        }
        if (val.length < 1) {
          this.addItem(0);
        }
      }
    }
  }
}
</script>